import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import AddEditUserDialog from "../../../components/Dialog/AddEditUserDialog";
import DynamicTable from "../../../components/DynamicTable";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import { fetchBusinessRole } from "../../../services/Roles";
import {
  createUser,
  getAllUserByBusiness,
  updateUser,
} from "../../../services/User";
import { updateUserValidation } from "../../../utils/Validation";

const headerData = ["User Name", "Designation", "Status", "Action"];

const tableRows = ["username", "role_name", "status", "actions"];

function AllUsers({ setIsLoading }) {
  const openDialog = useRef();
  const [open, setOpen] = useState(false);

  const [allUsersData, setAllUsersData] = useState([]);
  const { user } = useSelector((state) => state.user);
  const [assignedRoutes, setAssignedRoutes] = useState(null);
  const [allRoles, setAllRoles] = useState([]);
  const [inputValues, setInputValues] = useState({
    firstName: "",
    lastName: "",
    contactNumber: "",
    email: "",
    password: "",
    assingedRole: "",
  });
  const [inputError, setInputError] = useState({
    firstName: false,
    lastName: false,
    contactNumber: false,
    assingedRole: false,
    email: false,
    isEmailValid: false,
    password: false,
  });
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleIconClick = (id) => {
    setAssignedRoutes((prevRoutes) =>
      prevRoutes.map((route) =>
        route.id === id ? { ...route, selected: !route.selected } : route
      )
    );
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const fetchAllUsers = async () => {
    try {
      setIsLoading(true);
      const responce = await getAllUserByBusiness(user?.businessId);
      setIsLoading(false);
      let data = responce?.data?.data;
      if (responce.status == 200 || responce.status == 201) {
        setAllUsersData(data);
      }
    } catch (error) {
      console.log("🚀 ~ fetchAllUsers ~ error:", error);
    }
  };

  const handleGetRoles = async () => {
    try {
      setIsLoading(true);
      const responce = await fetchBusinessRole(user?.businessId);
      let data = responce?.data?.data;
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        setAllRoles(data);
      }
    } catch (error) {
      console.log("🚀 ~ handleAddEditRoles ~ error:", error);
    }
  };

  const handleChageInputs = (e) => {
    const { name, value } = e.target;

    setInputError((prev) => ({
      ...prev,
      [name]: false,
      isEmailValid: name === "email" ? false : prev.isEmailValid,
    }));

    setInputValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectOption = (item) => {
    setInputValues((prev) => ({
      ...prev,
      assingedRole: item,
    }));
  };

  const handleAddEditCategory = async (data) => {
    try {
      const validate = updateUserValidation(inputValues, setInputError, data);
      if (validate) {
        return;
      }
      let payload = {
        firstname: data?.firstName,
        lastname: data?.lastName,
        email: data?.email,
        contactNumber: data?.contactNumber,
        password: data?.password,
        businessId: user?.businessId,
        role: data?.assingedRole,
      };
      setIsLoading(true);
      const responce =
        data?.type == "add"
          ? await createUser(payload)
          : await updateUser(data?.id, payload);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        fetchAllUsers();
        handleClose();
        handleSnackbarVal(true, "success", responce?.data?.message);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log("🚀 ~ handleAddEditCategory ~ error:", error);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setInputValues({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      assingedRole: "",
    });
    setInputError({
      firstName: false,
      lastName: false,
      assingedRole: false,
      email: false,
      isEmailValid: false,
      password: false,
    });
  };

  const handleEditUsers = (row, ind) => {
    openDialog.current.isVisible({ type: "edit", data: row });
  };

  const handleDelete = async (row, ind) => {
    try {
      setIsLoading(true);
      const responce = false;
      setIsLoading(false);
      if (responce.status == 200 || responce?.status == 201) {
        handleSnackbarVal(true, "success", responce.data.message);
        fetchAllUsers();
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error.data.message);
      console.log("🚀 ~ handleDelete ~ error:", error);
    }
  };

  const handleChangeStatus = async (row) => {
    try {
      setIsLoading(true);
      const responce = await updateUser(row?._id, { status: !row?.status });
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        fetchAllUsers();
        handleClose();
        handleSnackbarVal(true, "success", responce?.data?.message);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleSnackbarVal(true, "error", error?.data?.message);
      console.log("🚀 ~ handleChangeStatus ~ error:", error);
    }
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"Create New Users"}
            styleProps={{ fontWeight: 400, width: "auto" }}
            handleClickBtn={() =>
              openDialog.current.isVisible({ type: "add", data: {} })
            }
          />
        </Box>
      </Stack>
    );
  };

  return (
    <>
      <AppContainer
        primaryHeading={"Create user"}
        secondaryHeading={"View, edit and delete your created Users."}
        headProps={renderRightPart()}
      >
        {allUsersData?.length > 0 ? (
          <DynamicTable
            tableHeader={headerData}
            displayRows={tableRows}
            tableData={allUsersData}
            showEdit={true}
            // showDelete={true}
            handleDelete={(row) => handleDelete(row)}
            assignedRoutes={assignedRoutes}
            handleChangeStatus={handleChangeStatus}
            handleEdit={handleEditUsers}
          />
        ) : (
          <Stack height="100%" justifyContent="center">
            <Typography
              fontSize={18}
              fontWeight={800}
              color="#000"
              textAlign="center"
            >
              No User Found!
            </Typography>
          </Stack>
        )}
      </AppContainer>
      <AddEditUserDialog
        ref={openDialog}
        inputError={inputError}
        inputValues={inputValues}
        setInputValues={setInputValues}
        allRoles={allRoles}
        open={open}
        setOpen={setOpen}
        handleGetRoles={handleGetRoles}
        handleChageInputs={handleChageInputs}
        handleSelectOption={handleSelectOption}
        handleAddEditCategory={handleAddEditCategory}
        handleClose={handleClose}
      />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </>
  );
}

export default AllUsers;
